import React, { useEffect, useMemo, useState } from 'react'
import MasterService from '../../../services/master/MasterService'
import { Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import Disposisi from '../../../utilities/Disposisi'
import DataTable from 'react-data-table-component'
import { FaMinus, FaPlus } from 'react-icons/fa'

const ModalPnbpV2 = ({ showAddPnbp, handleClosePnbp, dataDisposisi, handleClickPilih }) => {

    let masterService = useMemo(() => new MasterService(), [])
    const [rootPnbp, setRootPnbp] = useState([])

    const columnsRoot = [
        {
            name: 'Kode Tarif',
            cell: row => row['kdTarif']
        },
        {
            name: 'Nama Tarif',
            cell: row => row['nmTarif']
        },
        {
            name: 'Satuan',
            cell: row => row['satuan']
        },
        {
            name: 'Tarif',
            cell: row => row['tarif']
        },
        {
            cell: row => (
                <>
                    {row['tarif'] !== 0 &&
                        <div className="row">
                            <div className="col-sm-12">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Pilih</Tooltip>
                                }>
                                    <Button size="sm" variant="primary" onClick={() => handleClickPilih(row)}>
                                        Pilih
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    }
                </>
            )
        }
    ]

    useEffect(() => {
        const getRootPnbp = async () => {
            try {
                const resRootPnbp = await masterService.listTarifPnbpV2(0)
                // console.log(resRootPnbp.data)
                setRootPnbp(resRootPnbp.data)
            } catch (error) {
                console.log(error)
                setRootPnbp([])
            }
        }
        getRootPnbp()
    }, [masterService])

    const onChangeSearch = async (e) => {
        try {
            const resPnbp = await masterService.listTarifPnbpV2ByNama(e.target.value)
            setRootPnbp(resPnbp.data)
        } catch (error) {

        }
    }

    return (
        <>
            <Modal
                show={showAddPnbp}
                onHide={handleClosePnbp}
                backdrop='static'
                keyboard={false}
                size='xl'
                centered
            >
                <Modal.Header>
                    <h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-6">
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="1" className="control-label align-self-center mb-0" htmlFor="searchNib">Cari</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="Jenis Pemeriksaan" className="form-control-sm" onChange={(e) => onChangeSearch(e)} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="table-responsive border-bottom my-3">
                    <DataTable
                        columns={columnsRoot}
                        data={rootPnbp}
                        highlightOnHover
                        expandableRows
                        expandableRowsComponent={({ data }) => <ExpandableTree parentId={data.id} key={data.id} handleClickPilih={handleClickPilih} />}
                        expandableIcon={{
                            collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                            expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                        }}
                    />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" size="sm" onClick={handleClosePnbp}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

const ExpandableTree = ({ parentId, key, handleClickPilih }) => {
    let masterService = useMemo(() => new MasterService(), [])

    const columnsChild = [
        {
            // name: '',
            cell: row => row['kdTarif']
        },
        {
            // name: '',
            cell: row => row['nmTarif']
        },
        {
            // name: '',
            cell: row => row['satuan']
        },
        {
            // name: '',
            cell: row => row['tarif']
        },
        {
            cell: row => (
                <>
                    {row['tarif'] !== 0 &&
                        <div className="row">
                            <div className="col-sm-12">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Pilih</Tooltip>
                                }>
                                    <Button size="sm" variant="primary" onClick={() => handleClickPilih(row)}>
                                        Pilih
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    }
                </>
            )
        }
    ]

    const [childPnbp, setChildPnbp] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getChildTarif = async () => {
            setLoading(true)
            try {
                const resPnbp = await masterService.listTarifPnbpV2(parentId)
                // console.log(resPnbp.data)
                setChildPnbp(resPnbp.data)
            } catch (error) {
                console.log(error)
                setChildPnbp([])
            }
            setLoading(false)
        }
        getChildTarif()
    }, [masterService, parentId])

    const customStyles = {
        headRow: {
            style: {
                display: "none", // Hide all headers
            },
        },
    };

    return (
        <>
            {loading && <Spinner />}
            <div style={{ paddingLeft: 30 }}>
                <DataTable
                    key={key}
                    customStyles={customStyles}
                    columns={columnsChild}
                    data={childPnbp}
                    expandableRows
                    expandableRowsComponent={({ data }) => <ExpandableTree parentId={data.id} key={data.id} handleClickPilih={handleClickPilih} />}
                    expandableIcon={{
                        collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                        expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                    }}
                />
            </div>
        </>
    )
}

export default ModalPnbpV2